import { render, staticRenderFns } from "./vehicleTypeTable.vue?vue&type=template&id=0fba23ff&scoped=true"
import script from "./vehicleTypeTable.vue?vue&type=script&lang=js"
export * from "./vehicleTypeTable.vue?vue&type=script&lang=js"
import style0 from "./vehicleTypeTable.vue?vue&type=style&index=0&id=0fba23ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fba23ff",
  null
  
)

export default component.exports